import { render, staticRenderFns } from "./value-selector.vue?vue&type=template&id=c04a5112&scoped=true&"
import script from "./value-selector.vue?vue&type=script&lang=js&"
export * from "./value-selector.vue?vue&type=script&lang=js&"
import style0 from "./value-selector.vue?vue&type=style&index=0&id=c04a5112&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04a5112",
  null
  
)

export default component.exports